import { Validators } from '@angular/forms';
import { FormConfig } from '../edit-create-form.interfaces';
import { AppValidators } from '@shared/validators/app-validators';
import { inject } from '@angular/core';
import { ClusterApiService } from '@shared/services';
import { CLUSTER_TREE_SELECT_CONFIG } from '@shared/components/generic-treeselect/generic-treeselect.configs';
import { CENTER_COLOR_PRESET_CONFIG } from '@shared/components/generic-colorpreset/generic-colorpreset.configs';
import { CENTER_TAG_COLOR_CONFIG, CENTER_TAG_TEXT_COLOR_CONFIG } from '@shared/components/generic-colorpicker/generic-colorpicker.configs';

export const centerFormConfig = (): FormConfig => {
  const clusterApiService = inject(ClusterApiService);



  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã trung tâm', required: true, width: 'half',
        type: 'text', validators: [Validators.pattern(/^[A-Z0-9-]+$/)],
        placeholder: 'Chữ hoa, số, dấu gạch ngang',
        tooltip: (editMode: boolean, formValue: any) =>
          editMode && formValue.code ? 'Không thể sửa mã trung tâm đã có' : '',
        customErrorMessage: 'Mã trung tâm là bắt buộc và chỉ chứa chữ hoa, số, dấu gạch ngang',
        disabled: (editMode: boolean, formValue: any) => editMode && formValue.code
      },
      {
        key: 'name', label: 'Tên trung tâm', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập tên trung tâm'
      },
      {
        key: 'clusterId', label: 'Cụm', required: true, width: 'half',
        type: 'treeselect', config: { ...CLUSTER_TREE_SELECT_CONFIG, service: clusterApiService }
      },
      {
        key: 'phone', label: 'Số điện thoại', width: 'half',
        type: 'text', validators: [AppValidators.vnPhone], placeholder: 'Nhập số điện thoại',
        customErrorMessage: 'Số điện thoại không hợp lệ - nếu có ? tức là dư số',
        autoFormat: 'vnPhone'
      },
      {
        key: 'address', label: 'Địa chỉ', width: 'full',
        type: 'text', placeholder: 'Nhập địa chỉ trung tâm'
      },
      {
        key: 'gMapLink', label: 'Link Google Maps', width: 'full',
        type: 'text', placeholder: 'Nhập link Google Maps'
      },
      {
        key: 'lat', label: 'Vĩ độ', width: 'half',
        type: 'text', validators: [Validators.pattern(/^-?\d+(\.\d+)?$/)], placeholder: 'Nhập vĩ độ',
        customErrorMessage: 'Vĩ độ phải là số hợp lệ'
      },
      {
        key: 'lng', label: 'Kinh độ', width: 'half',
        type: 'text', validators: [Validators.pattern(/^-?\d+(\.\d+)?$/)], placeholder: 'Nhập kinh độ',
        customErrorMessage: 'Kinh độ phải là số hợp lệ'
      },
      {
        key: 'active', label: 'Tình trạng', width: 'half',
        type: 'toggleSwitch', placeholder: 'Cơ sở đang hoạt động?'
      },
      {
        key: 'colorPreset',
        label: 'Bộ màu có sẵn',
        type: 'colorpreset',
        width: 'full',
        config: CENTER_COLOR_PRESET_CONFIG,
        showDividerAfter: true
      },
      {
        key: 'tagColor',
        label: 'Màu nền thẻ',
        type: 'colorpicker',
        width: 'half',
        config: CENTER_TAG_COLOR_CONFIG,
        dependsOn: 'colorPreset'
      },
      {
        key: 'tagTextColor',
        label: 'Màu chữ thẻ',
        type: 'colorpicker',
        width: 'half',
        config: CENTER_TAG_TEXT_COLOR_CONFIG,
        dependsOn: 'colorPreset'
      }
    ]
  };
};
